exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".corssTable table {\n  box-sizing: border-box;\n  text-align: center;\n  border: 1px solid #dcdee2;\n  padding: 5px 10px;\n}\n.corssTable table tr td {\n  padding: 5px 0;\n}\n", ""]);

// exports
